import http from '@homeservices/api-kit/axios';


export default {
  namespaced: true,
  state () {
    return {
      occupations: null,
      services: null,
      associatedServices: null,

    };
  },
  getters: {
    occupationsWithServices (state) {
      return state.occupations.map((occupation) => {
        const service_ids = state.associatedServices.filter((service) => {
          return service.occupation_identifier === occupation.occupation_id
            && service.occupation_service_status === 'Active';
        })
          .map(service => state.services.find((obj) => {
            return obj.service_identifier === service.service_identifier;
          }))
          .filter(item => item !== undefined)
          .map(service => service.service_display_name);
        return { name: occupation.occupation_display_name, services: service_ids };
      });
    },
  },
  actions: {
    async fetchProOccupationsWithServices ({ dispatch }) {
      await Promise.all([
        dispatch('getOccupations'),
        dispatch('getServices'),
        dispatch('getAssociatedServices'),
      ]);
    },
    async getOccupations ({ commit, dispatch }, results = []) {
      const { data } = await http.get(`/platform/servicecatalog/api/servicecatalog/v1/occupations/occupationFeed?size=1000&from=${results.length}`);
      const { total } = data;
      const totlaResults = [...results, ...data.results];

      if (totlaResults.length < total) {
        return dispatch('getOccupations', totlaResults);
      }
      const occupations = totlaResults.filter((occupation) => {
        return occupation.occupation_status === 'Active' && occupation.onboardable_flag === 'true'
            && occupation.occupation_id !== 1; // 1 is Accountant which passes the other two checks
      });
      commit('setOccupations', occupations);
    },
    async getAssociatedServices ({ commit, dispatch }, results = []) {
      const { data } = await http.get(`/platform/servicecatalog/api/servicecatalog/v1/occupations/associatedServiceFeed?size=1000&from=${results.length}`);
      const { total } = data;
      const totlaResults = [...results, ...data.results];

      if (totlaResults.length < total) {
        return dispatch('getAssociatedServices', totlaResults);
      }
      const associatedServices = totlaResults.filter((service) => {
        return service.occupation_service_status === 'Active';
      });
      commit('setAssociatedServices', associatedServices);
    },
    async getServices ({ commit, dispatch }, results = []) {
      const { data } = await http.get(`/platform/servicecatalog/api/servicecatalog/v1/services/serviceFeed?size=1000&from=${results.length}`);
      const { total } = data;
      const totlaResults = [...results, ...data.results];

      if (totlaResults.length < total) {
        return dispatch('getServices', totlaResults);
      }
      const services = totlaResults.filter((service) => {
        return service.service_status === 'Active' && service.service_onboardable_flag === true;
      });
      commit('setServices', services);
    },
  },
  mutations: {
    setOccupations (state, data) {
      state.occupations = data;
    },
    setServices (state, data) {
      state.services = data;
    },
    setAssociatedServices (state, data) {
      state.associatedServices = data;
    },
  },
};
